var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC34CF1A-B45A-4D54-96E0-7EFFFBB9DB18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messagingCalendarEvent",
    transform: "translate(-1279.000000, -1018.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groupChatBody",
    transform: "translate(390.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message0User1-Copy-2",
    transform: "translate(400.000000, 699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messsageControls",
    transform: "translate(460.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Share/Fill",
    transform: "translate(29.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt_Bounding_Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 19 0 19 19 0 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25,11.875 L14.2500001,11.875 C13.6280652,11.8755132 13.0311501,12.1199654 12.5875001,12.5558333 L6.33333345,9.76916667 L6.33333345,9.5 L6.33333345,9.23875 L12.5875001,6.44416667 L12.5875002,6.44416675 C13.5242239,7.36234175 15.0279156,7.34730008 15.9460906,6.41057578 C16.8642656,5.47385203 16.8492239,3.97016036 15.9124996,3.05198536 C14.9757759,2.13381036 13.4720842,2.14885203 12.5539092,3.08557633 C12.1182796,3.53000771 11.8744961,4.12767092 11.8750004,4.75000008 L11.8750004,5.01916675 L5.62083377,7.80583342 L5.62083382,7.80583347 C4.68517091,6.8865818 3.18146341,6.8998818 2.26221174,7.83554084 C1.34296007,8.77120376 1.35626007,10.2749113 2.29191911,11.1941629 C3.21589703,12.1019433 4.69685994,12.1019433 5.62083786,11.194163 L11.8750045,13.9887464 L11.8750045,14.2499964 L11.8750045,14.2499967 C11.8750047,15.5616696 12.9383316,16.6249967 14.2500045,16.6249967 C15.5616774,16.6249967 16.6250045,15.5616696 16.6250045,14.2499967 C16.6250045,12.9383238 15.5616774,11.8749967 14.2500045,11.8749967 L14.25,11.875 Z",
    id: "Fill"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e11b30a08f34405ba6a3999795100b6b.svg";
export { ForwardRef as ReactComponent };